<template>
  <!-- fixedBox -->
  <div class="fixedBox">
    <!-- pc导航 -->
    <section class="pc">
      <!-- <div class="iphoneX">
        <section class="line"></section>
      </div> -->
      <button :class="isShow?'shut':'open'" @click="packsAnimate($event,220)"></button>
      <section>
        <p :class="[activeIndex==0?'active':'','ban']" v-scroll-to="{el:`#scrollOne`}">Đặt gạch</p>
        <p :class="[activeIndex==1?'active':'','ban']" v-scroll-to="{el:`#scrollTow`}">Rút thưởng</p>
        <p
          :class="[activeIndex==2?'active':'','ban']"
          v-scroll-to="{el:`#scrollThree`}"
        >Giới thiệu tướng</p>
        <a href="https://www.facebook.com/tamquocbumchiu2/" target="_blank">
          <p class="fans"></p>
        </a>
        <a href="http://bit.ly/2ve0bh6" target="_blank">
          <p class="google"></p>
        </a>
        <button class="goTop" v-scroll-to="{el:`#scrollOne`}"></button>
      </section>
      <div class="zui move"></div>
    </section>
    <!-- 移动端导航 -->
    <section class="mobile">
      <div class="logoBox">
        <div class="mobileIcon"></div>
        <!-- <div class="moblieLogo"></div> -->
        <a href="http://bit.ly/2ve0bh6" target="_blank">
          <p class="mobileGoogle"></p>
        </a>
        <a href="https://www.facebook.com/tamquocbumchiu2/">
          <div class="mobileFans"></div>
        </a>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  name: "navigation",
  data() {
    return {
      isShow: 1,
      isActive:true,
      activeIndex: 0,
      isShowPacks: true
    };
  },
  created() {
    window.addEventListener("scroll", this.isScroll);
  },
  methods: {
    /****************************************************************/
    isScroll(ev) {
      var scrollTop =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop;
      if (scrollTop >= 0 && scrollTop < 932) {
        this.activeIndex = 0;
      } else if (scrollTop >= 932 && scrollTop < 2322) {
        this.activeIndex = 1;
      } else if (scrollTop >= 2322) {
        this.activeIndex = 2;
      }
    },
    packsAnimate($event, width) {
      if (this._packAnimate) return;
      let packWrap = $event.target.parentNode;
      let right = this.isShowPacks ? 0 : -width;
      let t = this.isShowPacks ? -8 : 8;
      this._packAnimate = true;
      this.isShow = !this.isShow
      let timer = setInterval(() => {
        right += t;
        if (-1 * right > width || right > 0) {
          clearInterval(timer);
          right = right < 0 ? -width : 0;
          this.isShowPacks = !this.isShowPacks;
          this._packAnimate = false;
        }
        packWrap.style.right = right + "px";
      }, 20);
    }
  }
};
</script>
<style lang="scss" scoped>
/*---- variables ----*/
$pc: "screen and (min-width: 751px)";
$mobile: "screen and (max-width: 750px) and (min-width: 0px)";

/*---- Mixins ----*/
@mixin mq($mqString) {
  @media #{$mqString} {
    @content;
  }
}
@include mq($pc) {
  .mobile {
    display: none;
  }
  .pc {
    display: block;
    width: 271px;
    height: 528px;
    position: fixed;
    top: 100px;
    right: 0;
    z-index: 9;
    .shut,
    .open {
      width: 31px;
      height: 63px;
      border: 1px solid;
      position: absolute;
      top: 247px;
      left: 15px;
      background: url("./img/shut.png") no-repeat center;
    }
    .open {
      background: url("./img/open.png") no-repeat center;
    }
    section {
      width: 242px;
      height: 606px;
      background: url("./img/fixedBg2.png") no-repeat center;
      background-size: 100%;
      float: right;
      text-align: center;
    }
    .active {
      font-weight: bold;
      font-size: 24px;
    }
    .ban {
      width: 81%;
      margin: auto;
      font-size: 24px;
      line-height: 55px;
      color: #4c260f;
      cursor: pointer;
    }
    .ban:nth-child(1) {
      margin-top: 189px;
    }
    .fans {
      width: 178px;
      height: 56px;
      margin-top: 12px;
      margin-left: 37px;
      background: url("./img/fans.png") no-repeat;
    }
    .google{
      width: 179px;
      height: 63px;
      margin-top: 12px;
      margin-left: 37px;
      background: url("./img/google.png") no-repeat;
    }
    .goTop {
      width: 40px;
      height: 35px;
      line-height: 100px;
      float: left;
      margin-left: 105px;
      margin-top: 5px;
    }
    .zui {
      width: 124px;
      height: 227px;
      background: url("./img/zui.png") no-repeat;
      position: absolute;
      top: 489px;
      left: 129px;
    }
    .move {
      -webkit-animation: go 2s ease-in-out alternate infinite;
      -moz-animation: go 2s ease-in-out alternate infinite;
      animation: go 2s ease-in-out alternate infinite;
    }
    @keyframes go {
      0% {
        -webkit-transform: rotate(5deg);
        -webkit-transform-origin: top center;
        -moz-transform: rotate(5deg);
        -moz-transform-origin: top center;
        transform: rotate(5deg);
        transform-origin: top center;
      }
      100% {
        -webkit-transform: rotate(-5deg);
        -webkit-transform-origin: top center;
        -moz-transform: rotate(-5deg);
        -moz-transform-origin: top center;
        transform: rotate(-5deg);
        transform-origin: top center;
      }
    }
    @-webkit-keyframes changeImg {
      from {
        left:-100%;
      }
      100% {
        left:150%;
      }
    }
    .iphoneX {
      width: 162px;
      height: 120px;
      position: relative;
      border: 1px solid;
      overflow: hidden;
      .line{
      position:absolute;
      -webkit-animation:changeImg 3s ease 0s;
      -o-animation:changeImg 3s ease 0s;
      animation:changeImg 3s ease 0s;
      top:0;
      width:30%;
      height:100%;
      content:"";
      background:-webkit-linear-gradient(left,rgba(255,255,255,0) 0,rgba(255,255,255,.4) 50%,rgba(255,255,255,0) 100%);
      background:-o-linear-gradient(left,rgba(255,255,255,0) 0,rgba(255,255,255,.4) 50%,rgba(255,255,255,0) 100%);
      background:-moz-linear-gradient(left,rgba(255,255,255,0) 0,rgba(255,255,255,.4) 50%,rgba(255,255,255,0) 100%);
      background:linear-gradient(to right,rgba(255,255,255,0) 0,rgba(255,255,255,.4) 50%,rgba(255,255,255,0) 100%);
      transform:skewX(-45deg);
      animation-iteration-count:infinite;
      -moz-animation-iteration-count:infinite;
      -webkit-animation-iteration-count:infinite;
      }
    }
    // .iphoneX {
    //   width: 120px;
    //   height: 162px;
    //   position: absolute;
    //   left: 109px;
    //   top: 11px;
    //   // border:1px solid red;
    //   overflow: hidden;
    //   cursor: pointer;
    // }
    // .iphoneX:hover:after{
		// 	left: -100%;
	  //   transition: 1s ease;  /* 图二效果*/
		// }
    // .iphoneX:after{
		// 	position: absolute;
		// 	left: 150%;                    /*改变left的值，让其相对box影藏*/
		// 	top: 0;
		// 	width: 30%;
		// 	height: 100%;
		// 	content: "";
		// 	/* Safari 5.1 - 6.0 */
		//   background: -webkit-linear-gradient(left,rgba(255,255,255,0) 0,rgba(255,255,255,.3) 50%,rgba(255,255,255,0) 100%);
		//   /* Opera 11.1 - 12.0 */
		//   background: -o-linear-gradient(left,rgba(255,255,255,0) 0,rgba(255,255,255,.3) 50%,rgba(255,255,255,0) 100%);
		//   /* Firefox 3.6 - 15 */
		//   background: -moz-linear-gradient(left,rgba(255,255,255,0) 0,rgba(255,255,255,.3) 50%,rgba(255,255,255,0) 100%);
		//   /* 标准的语法 */
		//   background: linear-gradient(to right,rgba(255,255,255,0) 0,rgba(255,255,255,.3) 50%,rgba(255,255,255,0) 100%);
	  //   transform: skewX(-45deg);
    //   transition: 1s ease;
		// }

  }
}
@include mq($mobile) {
  .pc {
    display: none;
  }
  .mobile {
    display: block;
    width: 100%;
    height: 155px;
    background: #2c1206;
    position: fixed;
    top: 0px;
    right: 0;
    z-index: 9;
    .logoBox {
      width: 640px;
      height: 150px;
      margin: auto;
      div {
        float: left;
      }
      .mobileIcon {
        width: 126px;
        height: 126px;
        margin-top: 14.5px;
        background: url("./img/fixIcon1.png") no-repeat center;
      }
      .moblieLogo {
        width: 246px;
        height: 103px;
        position: absolute;
        top:160px;
        left: 0px;
        background: url("./img/fixIcon2.png") no-repeat center;
      }
      .mobileGoogle{
        width: 236px;
        height: 74px;
        float: right;
        margin-left: 20px;
        margin-top: 39.5px;
        background: url("./img/google.png") no-repeat center;
        background-size: 100% 100%;

      }
      .mobileFans {
        width: 236px;
        height: 74px;
        float: right;
        margin-top: 39.5px;
        background: url("./img/fixIcon3.png") no-repeat center;
      }
    }
  }
}
</style>
